/* Argentinísimo · BLACK FRIDAY 2026
   1) Copiar código ([data-bf-copy])
   2) Progreso del combo en la home ([data-bf-progress])
   3) Carrito lateral: mensajes del combo, descuentos activos, cupón BLACK10 y beneficios.
      No toca el HTML ni la lógica del carrito: solo agrega información encima del cajón existente.
   Todo sale de /cart.js: la cantidad es la real y la promo "activa" es la que Shopify aplicó
   (line_level_discount_allocations). El tema nunca calcula ni inventa descuentos.
   4) Pop-up discreto del cupón ([data-bf-toast]) */
(function () {
  if (window.__bfBlack) return;
  window.__bfBlack = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CODE = 'BLACK10';
  var TIERS = [{ take: 3, pay: 2 }, { take: 5, pay: 3 }, { take: 7, pay: 4 }, { take: 10, pay: 5 }];
  var lastCart = null; 
function contarCamisetas(cart) {
  return (cart.items || []).reduce(function(total, item) {
    var props = item.properties || {};
    var tipo = (item.product_type || '').toLowerCase();
    var titulo = (item.product_title || item.title || '').toLowerCase();

    var ehPatch =
      Boolean(props.Camisa) ||
      /^(patch|parche|badge)\b/.test(tipo) ||
      /^(patch|parche|badge)\b/.test(titulo);

    return total + (ehPatch ? 0 : item.quantity);
  }, 0);
}


  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (ok) {
      var t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t); ok();
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bf-copy]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-bf-copy');
    var label = btn.querySelector('[data-bf-label]') || btn;
    if (!btn.dataset.bfOrig) btn.dataset.bfOrig = label.textContent;
    var done = function () {
      label.textContent = btn.getAttribute('data-bf-done') || '¡Código copiado!';
      btn.classList.add('is-copied');
      var live = document.getElementById('bf-live');
      if (live) live.textContent = 'Código ' + code + ' copiado';
      clearTimeout(btn._bfT);
      btn._bfT = setTimeout(function () { label.textContent = btn.dataset.bfOrig; btn.classList.remove('is-copied'); }, 2400);
    };
    copyText(code).then(done, done);
  });

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function plural(n, a, b) { return n === 1 ? a : b; }
  function label(t) { return t.take + '×' + t.pay; }
  function money(cents, cur) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function appliedTier(cart) {
    var best = null;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var title = (a.discount_application && a.discount_application.title) || '';
        var m = title.match(/PAG[ÁA]\s*(\d+)\D+LLEV[ÁA]\s*(\d+)/i);
        if (m) { var t = { pay: +m[1], take: +m[2] }; if (!best || t.take > best.take) best = t; }
      });
    });
    return best;
  }
  function activeTitles(cart) {
    var out = [];
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && a.discount_application.title;
        if (t && out.indexOf(t) < 0) out.push(t);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.title && out.indexOf(d.title) < 0) out.push(d.title); });
    return out;
  }
  function codeApplied(cart) {
    var on = false;
    (cart.cart_level_discount_applications || []).forEach(function (d) { if ((d.title || '').toUpperCase() === CODE) on = true; });
    (cart.discount_codes || []).forEach(function (d) { if ((d.code || '').toUpperCase() === CODE && d.applicable) on = true; });
    return on;
  }
  function message(n, applied) {
    var next = null, reached = null;
    for (var i = 0; i < TIERS.length; i++) { if (n >= TIERS[i].take) reached = TIERS[i]; else if (!next) next = TIERS[i]; }
    if (n === 0) return { win: '', txt: 'Sumá 3 camisetas y una va de regalo.' };
    if (!reached) {
      var f = next.take - n;
      return { win: '¡Te ' + plural(f, 'falta ', 'faltan ') + f + plural(f, ' camiseta', ' camisetas') + ' para completar tu ' + label(next) + '!', txt: 'Mezclá clubes, selecciones y talles.' };
    }
    var shown = applied || reached;
    if (!next) {
      if (applied && applied.take === 10) return { win: '¡Tu combo está listo!', txt: 'Llevás 10 y pagás 5. Sumá BLACK10 para un 10% extra.' };
      return { win: '¡Ya desbloqueaste tu promo ' + label(shown) + '!', txt: 'El 10×5 aplica a camisetas seleccionadas: revisá tu combo.' };
    }
    var g = next.take - n;
    return { win: '¡Ya desbloqueaste tu promo ' + label(shown) + '!', txt: 'Sumá ' + g + ' más para el ' + label(next) + (next.take === 10 ? ' (camisetas seleccionadas).' : '.') };
  }

  function renderBox(box, cart) {
    var n = cart.item_count || 0;
    var fill = box.querySelector('[data-bf-fill]');
    if (fill) fill.style.width = Math.min(100, n * 10) + '%';
    box.querySelectorAll('[data-bf-ms]').forEach(function (ms) { ms.classList.toggle('is-on', n >= +ms.getAttribute('data-bf-ms')); });
    var c = box.querySelector('[data-bf-count]');
    if (c) c.textContent = n + plural(n, ' camiseta', ' camisetas');
    var msg = box.querySelector('[data-bf-msg]');
    if (msg) { var m = message(n, appliedTier(cart)); msg.textContent = (m.win ? m.win + ' ' : '') + m.txt; }
    var save = box.querySelector('[data-bf-save]');
    if (save) {
      if (cart.total_discount > 0) { save.hidden = false; save.textContent = 'Ahorro real en tu carrito: ' + money(cart.total_discount, cart.currency); }
      else save.hidden = true;
    }
  }

  function renderDrawer(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !cart) return;
    var n = cart.item_count || 0;
    
    var footer = drawer.querySelector('.drawer__footer');
    if (!footer || n === 0) return;
    var box = footer.querySelector('.bf-cart-extra');
    if (!box) {
      box = document.createElement('div');
      box.className = 'bf-cart-extra';
      var anchor = footer.querySelector('.argc-sum') || footer.querySelector('.cart-drawer__footer') || footer.firstChild;
      footer.insertBefore(box, anchor);
    }
    var titles = activeTitles(cart);
    var out = '';
    if (titles.length) out += '<ul class="bf-cart-active" role="list" aria-label="Descuentos activos">' + titles.map(function (t) { return '<li>✓ ' + esc(t) + '</li>'; }).join('') + '</ul>';
    if (codeApplied(cart)) {
      out += '<div class="bf-cart-coupon is-applied"><span class="bf-cart-coupon__txt"><b>BLACK10 aplicado ✓</b>Se suma a tu combo en el pago.</span></div>';
    } else {
      out += '<div class="bf-cart-coupon"><span class="bf-cart-coupon__txt"><b>+10% extra con BLACK10</b>Se suma a tu combo · 1 uso por cliente</span>' +
        '<button type="button" class="bf-code" data-bf-copy="' + CODE + '" data-bf-done="¡Copiado!"><span data-bf-label>Copiar</span></button>' +
        '<a class="bf-cart-coupon__apply" href="' + ROOT.replace(/\/$/, '') + '/discount/' + CODE + '?redirect=%2Fcheckout">Aplicar y pagar →</a></div>';
    }
    out += '<ul class="bf-cart-perks" role="list"><li>Envío gratis a Europa y EE.UU.</li><li>Nombre y número gratis</li><li>Pago seguro</li></ul>';
    if (box.getAttribute('data-bf') !== out) { box.innerHTML = out; box.setAttribute('data-bf', out); }
  }

  var boxes = document.querySelectorAll('[data-bf-progress]');
  function apply(cart) {
    lastCart = cart;
    boxes.forEach(function (b) { renderBox(b, cart); });
    renderDrawer(cart);
  }
  var pending = null;
  function load() {
    if (pending) return pending;
    pending = fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }
  function init() {
    load();
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(load, 120); }); } catch (e) {}
    }
    document.addEventListener('cart:updated', load);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) load(); });
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var d = document.getElementById('CartDrawer');
          if (!d) return;
          var stale = (d.querySelector('.argc-promo') && !d.querySelector('.argc-promo.bf-tone')) || (d.querySelector('.drawer__footer') && !d.querySelector('.bf-cart-extra'));
          if (stale) { if (lastCart) renderDrawer(lastCart); load(); }
        }, 60);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  var toast = document.querySelector('[data-bf-toast]');
  if (toast) {
    var KEY = 'bf26_toast';
    var seen = false;
    try { seen = !!sessionStorage.getItem(KEY) || (+localStorage.getItem(KEY) || 0) > Date.now(); } catch (e) {}
    if (!seen) {
      var shown = false;
      var onScroll = function () {
        var h = document.documentElement;
        if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.55) show();
      };
      var show = function () {
        if (shown) return;
        if (document.querySelector('cart-drawer.active, .drawer.active, .menu-opening')) return;
        shown = true;
        toast.hidden = false;
        requestAnimationFrame(function () { toast.classList.add('is-open'); });
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
        window.removeEventListener('scroll', onScroll);
      };
      setTimeout(show, (+toast.getAttribute('data-delay') || 25) * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
      toast.querySelector('[data-bf-toast-close]').addEventListener('click', function () {
        toast.classList.remove('is-open');
        setTimeout(function () { toast.hidden = true; }, 350);
        try { localStorage.setItem(KEY, String(Date.now() + 3 * 864e5)); } catch (e) {}
      });
    }
  }
})();
